import { Button, Form, Offcanvas } from "react-bootstrap";
import { formServices } from "../../../APIServices/VoultManagement/formServices";
import { useState } from "react";

const AddNewFormMeta = ({ Show, Hide, Title, getFormMetaList, categoryMetaList }) => {
  const [loader, setLoader] = useState(false);

  const [name, setName] = useState("");
  const [categoryId, setCategoryId] = useState("");

  const addNewMetadata = async () => {
    setLoader(true);
    const userData = {
      categoryId,
      name,
    };
    const data = await formServices.addNewFormMeta(userData);
    if (data?.statusCode === 200) {
      setName("");
      setCategoryId("");
      getFormMetaList();
      Hide();
    }
    setLoader(false);
  };

  return (
    <Offcanvas show={Show} onHide={Hide} placement="end">
      <Offcanvas.Header closeButton className="bg-light p-3 border-bottom">
        <Offcanvas.Title className="fw-bold" style={{ fontSize: 15 }}>
          {Title}
        </Offcanvas.Title>
      </Offcanvas.Header>
      <Offcanvas.Body>
        <Form.Group className="mb-2">
          <Form.Label className="fw-bold mb-1" style={{ fontSize: 13 }}>
            Category
          </Form.Label>
          <Form.Select
            className="interactive-input"
            style={{ fontSize: 12, padding: "6px 15px" }}
            onChange={(e) => setCategoryId(e.target.value)}
            value={categoryId}
          >
            <option value="">Select Category</option>
            {categoryMetaList?.map((item, index) => (
              <option key={index} value={item?.key}>{item?.name}</option>
            ))}
          </Form.Select>
        </Form.Group>
        <Form.Group className="mb-2">
          <Form.Label className="fw-bold mb-1" style={{ fontSize: 13 }}>
            Name
          </Form.Label>
          <Form.Control
            value={name}
            onChange={(e) => setName(e.target.value)}
            placeholder="Enter Name"
            style={{ fontSize: 12 }}
          />
        </Form.Group>
      </Offcanvas.Body>
      <div className="text-end p-2 border-top bg-light">
        <Button
          disabled={!name || !categoryId || loader}
          onClick={addNewMetadata}
          variant="outline-primary"
          style={{ fontSize: 13 }}
          className="rounded-2 py-1 px-3"
        >
          {loader ? "Saving..." : Title}
        </Button>
      </div>
    </Offcanvas>
  );
};

export default AddNewFormMeta;